export default __webpack_public_path__ + "static/media-md-45a55a7879c1949b53a28d9ee1cf2efb.png";